<template>
  <div class="stepCardWrapper">
    <div class="stepImage">
      <img :src="imageSource" alt="">
<!--      <div class="stepNumber" :style="stepStyles">{{stepNumber}}</div>-->
    </div>
    <div class="paragraph">
      <p v-for="field in fields" :key="field.fieldId">
            <componentRenderer v-bind:key="field.id" :field="field" />
        </p>
    </div>
  </div>
</template>

<script>
import componentRenderer from "@/components/component-renderer";

export default {
  name: "step-card",
  components: { componentRenderer },
  props: {
    fields: {
      required: false,
      type: Array,
      default: () => []
    },
    imageSource: {
      required: true,
      type: String
    },
    stepNumber: {
      required: true,
      type: [String, Number]
    },
    stepStyles: {
      required: false,
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.stepCardWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .stepImage {
      position: relative;
      margin: 5px;
    }

    .stepNumber {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: #D8D8D8;
        font-weight: bold;
        height: 35px;
        width: 35px;
        font-size: 14px;
        line-height: 24px;
        position: absolute;
        right: -40px;
        top: -8px;
    }
    .paragraph {
        margin-top: 20px;
        font-weight: bold;
        font-size: 12px;
        @media (min-width: 769px) {
          font-size: inherit;
        }
    }
    .stepImage img {
      height: 74px;
      width: 74px;
      border-radius: 50%;
      @media (min-width: 769px) {
        height: 100px;
        width: 100px;
      }
      @media (min-width: 1025px) {
        height: 150px;
        width: 150px;
      }
    }
    .stepImage:after {
      content: ' ';
      height: 26px;
      width: 150px;
      max-width: 100%;
      background-image: url(../../assets/icons/Arrow.svg);
      background-repeat: no-repeat;
      background-position: center;
      display: inline-block;
      position: absolute;
      top: 41%;
      margin-left: -14px;
    }
}
.stepCardWrapper:last-child {
  .stepImage:after {
    background-image: none;
  }
}
</style>
